import { render, staticRenderFns } from "./wrtable.vue?vue&type=template&id=22e29651&"
import script from "./wrtable.vue?vue&type=script&lang=js&"
export * from "./wrtable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports